import React, { memo } from 'react';
import styled from 'styled-components';

import Countdown from '../../../Countdown';

import { Circle } from '@icons/common';

interface IRoundCountDown {
  className?: string;
  seconds: number;
  onStop: () => void;
}

const RoundCountdown = ({ className, seconds, onStop }: IRoundCountDown) => {
  if (!Number.isInteger(seconds) && seconds <= 0) {
    return null;
  }

  return (
    <StyledRoundCountdown className={className}>
      <StyledCountdown format="ss" seconds={seconds} onStop={onStop} />
      <StyledCircleIcon duration={`${seconds}s`} />
    </StyledRoundCountdown>
  );
};

const StyledRoundCountdown = styled.div`
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  position: relative;
  border-radius: 100%;
  background: white;
`;

const StyledCountdown = styled(Countdown)`
  color: #4d4d4d;
  font-size: 12px;
  font-weight: normal;
`;

const StyledCircleIcon = styled(Circle)<{ duration: string }>`
  width: 24px;
  height: 24px;

  top: 0;
  left: 0;
  position: absolute;

  circle {
    stroke-width: 2;
    stroke: #00c781;
    stroke-dasharray: 70;
    stroke-dashoffset: 70;

    ${({ duration }) => `
      animation: progress ${duration} linear;
    `}
  }

  @keyframes progress {
    0% {
      stroke-dashoffset: 0;
    }
    100% {
      stroke-dashoffset: 70;
    }
  }
`;

export default memo(RoundCountdown);
